<template>
  <div>
    <i
      class="fas fa-user-check mr-1 fa-lg"
      v-b-tooltip.hover
      :title="dokumenteTooltipText"
      :class="statusClass(vorgang.teilnehmerdatenStatus)"
    ></i>
    <i
      class="fas fa-suitcase mr-1 fa-lg"
      v-b-tooltip.hover
      :title="reiseleistungenUndListenversandTooltipText"
      :class="statusClass(vorgang.reiseleistungListenversandStatus)"
    ></i>
    <i
      v-if="!isReiseOhneFlug"
      class="fas fa-plane mr-1 fa-lg"
      v-b-tooltip.hover
      :title="fluegeTooltipText"
      :class="statusClass(vorgang.fluegeStatus)"
    ></i>
    <i
      v-if="!dachReise && !isReiseOhneFlug"
      class="fas fa-car mr-1 fa-lg"
      v-b-tooltip.hover
      title="Transferplanung Vorgangebene"
      :class="statusClass(vorgang.transferplanungStatus)"
    ></i>
  </div>
</template>

<script>
const STATUS_CLASS_MAP = {
  AllGood: 'text-success',
  CheckRequired: 'text-warning',
  Critical: 'text-danger',
};

export default {
  props: {
    vorgang: { type: Object },
    isKeineTransferplanungNotwendigHin: { type: Boolean },
    isKeineTransferplanungNotwendigRueck: { type: Boolean },
    isReiseOhneFlug: { type: Boolean, default: false },
  },
  computed: {
    dachReise() {
      if (!this.vorgang || !this.vorgang.hotelleistungen) return false;
      return (
        this.vorgang.hotelleistungen.every(hl => hl.reisetermin?.reise?.region === 'Dach') ||
        (this.isKeineTransferplanungNotwendigHin && this.isKeineTransferplanungNotwendigRueck)
      );
    },
  },
  methods: {
    statusClass(status) {
      return STATUS_CLASS_MAP[status] || 'text-danger';
    },
    dokumenteTooltipText() {
      const status = this.vorgang.teilnehmerdatenStatus;
      if (status === 'AllGood') return 'Teilnehmerdaten vollständig.';
      if (status === 'CheckRequired') return 'Teilnehmerdaten teilweise unvollständig.';
      return 'Teilnehmerdaten unvollständig.';
    },
    reiseleistungenUndListenversandTooltipText() {
      const status = this.vorgang.reiseleistungListenversandStatus;
      return status === 'AllGood'
        ? 'Reiseleistungen & Listenversand geprüft.'
        : status === 'Critical'
        ? 'Reiseleistungen & Listenversand nicht geprüft.'
        : 'Prüfung Reiseleistungen & Listenversand in Arbeit.';
    },
    fluegeTooltipText() {
      if (this.vorgang.fluegeStatus === 'AllGood') {
        return 'Flüge durch FOM geprüft.';
      }
      if (this.vorgang.fluegeStatus === 'CheckRequired' || this.vorgang.fluegeStatus === 'Critical') {
        return 'Flüge durch FOM nicht geprüft.';
      }

      return `Flüge ${this.vorgang.fluegeStatus === 'Critical' ? '' : 'nicht'} geprüft & Flugticket ${
        this.vorgang.flugticketAusgestellt ? '' : 'nicht'
      } ausgestellt.`;
    },
  },
};
</script>
